import { useMemo } from 'react'
import { Field } from 'react-final-form'

import useRegionsListQuery from 'common/api/queries/useRegionsListQuery'
import { SelectValue } from 'common/components/BaseSelect'
import FormItem from 'common/components/formItem'
import SingleSelect from 'common/components/singleSelect'

const IsoLanguageField = ({
  isEditMode,
  isRuleLimitReached,
}: {
  isEditMode: boolean
  isRuleLimitReached: boolean
}) => {
  const { data: regionsData, status: regionStatus } = useRegionsListQuery()

  const regionOptions = useMemo(
    () => [
      { value: 'all', label: 'All Languages' },
      ...(regionsData
        ?.map(({ id, name }) => ({
          value: id,
          label: name,
        }))
        .sort((a, b) => a.label.localeCompare(b.label)) || []),
    ],
    [regionsData]
  )

  return (
    <Field<SelectValue> name="region">
      {({ input }) => (
        <FormItem
          label="ISO Language"
          htmlFor="region"
          error={
            isRuleLimitReached
              ? 'Please, select a different language.'
              : undefined
          }
        >
          <SingleSelect
            className="w-90"
            data-testid="region-select"
            name="region"
            placeholder="Select your ISO language"
            value={input.value.value}
            onChange={input.onChange}
            onBlur={input.onBlur}
            options={regionOptions}
            isDisabled={isEditMode}
            isLoading={regionStatus === 'loading'}
          />
        </FormItem>
      )}
    </Field>
  )
}

export default IsoLanguageField
